import { Injectable } from '@angular/core';
import { JourneyService } from '../../shared/service/journey/journey.service';
import { LogService } from "../../shared/service/log/log.service";

@Injectable({
  providedIn: 'root'
})
export class PersonalDataService {

  private readonly STEP_CODE = 'personal-data';
  changeBirthState = false;
  birthStatePrevious: { uf: string; ufName: string };

  constructor(private journeyService: JourneyService, private logService: LogService) {
  }



  public setDocumentTypeNameData(documentDataName: string) {
    this.journeyService.registratioJourney.data.personalData.documentTypeName = documentDataName;
  }

  public setDocumentTypeData(documentDataId: string) {
    this.journeyService.registratioJourney.data.personalData.documentType = documentDataId;
    this.setIsCompleteStepData();
    this.journeyService.changeDataEvent(this.STEP_CODE, this.journeyService.registratioJourney.data.personalData);
  }

  public getDocumentTypeData() {
    return this.journeyService.registratioJourney.data.personalData.documentType;
  }

  public getDocumentTypeNameData() {
    return this.journeyService.registratioJourney.data.personalData.documentTypeName;
  }


  public setFullName(fullName: string) {
    this.journeyService.registratioJourney.data.personalData.documentName = fullName;
    this.setIsCompleteStepData();
    this.journeyService.changeDataEvent(this.STEP_CODE, this.journeyService.registratioJourney.data.personalData);
  }

  public setDocumentNumber(documentNumber: string) {
    this.journeyService.registratioJourney.data.personalData.documentNumber = documentNumber;
    this.setIsCompleteStepData();
    this.journeyService.changeDataEvent(this.STEP_CODE, this.journeyService.registratioJourney.data.personalData);
  }

  public setDocumentIssuingName(documentIssuingName: string) {
    this.journeyService.registratioJourney.data.personalData.issuingAgencyName = documentIssuingName;
  }

  public setDocumentIssuing(documentIssuing: string) {
    this.journeyService.registratioJourney.data.personalData.issuingAgency = documentIssuing;
    this.setIsCompleteStepData();
    this.journeyService.changeDataEvent(this.STEP_CODE, this.journeyService.registratioJourney.data.personalData);
  }

  public setExpeditionStateName(expeditionStateName: string) {
    this.journeyService.registratioJourney.data.personalData.expeditionStateName = expeditionStateName;
  }

  public setExpeditionState(expeditionState: string) {
    this.journeyService.registratioJourney.data.personalData.expeditionState = expeditionState;
    //fix send expedition date to IOS. Remover apenas quando a versão entrar na loja.
    this.journeyService.registratioJourney.data.personalData.ufOfTheIssuingAgency = expeditionState;
    this.setIsCompleteStepData();
    this.journeyService.changeDataEvent(this.STEP_CODE, this.journeyService.registratioJourney.data.personalData);
  }

  public setBirthStateName(birthStateName: string) {
    this.journeyService.registratioJourney.data.personalData.uFOfBirthName = birthStateName;
  }

  public setBirthState(birthState: string) {
    if (birthState !== this.journeyService.registratioJourney.data.personalData.uFOfBirth) {
      this.changeBirthState = true;
    }
    this.journeyService.registratioJourney.data.personalData.uFOfBirth = birthState;
    this.setIsCompleteStepData();
  }

  public setBirthCountryName(birthCountryName: string) {
    this.journeyService.registratioJourney.data.personalData.countryOfBirthName = birthCountryName;
  }

  public setBirthCountry(birthCountry: string) {
    this.journeyService.registratioJourney.data.personalData.countryOfBirth = birthCountry;
    this.setIsCompleteStepData();
    this.journeyService.changeDataEvent(this.STEP_CODE, this.journeyService.registratioJourney.data.personalData);
  }

  public setBirthCity(birthCity: string) {
    this.journeyService.registratioJourney.data.personalData.cityOfBirth = birthCity;
    this.changeBirthState = false;
    this.setIsCompleteStepData();
    this.journeyService.changeDataEvent(this.STEP_CODE, this.journeyService.registratioJourney.data.personalData);
  }

  public setBirthCityName(birthCityName: string) {
    this.journeyService.registratioJourney.data.personalData.cityOfBirthName = birthCityName;
    this.setIsCompleteStepData();
    this.journeyService.changeDataEvent(this.STEP_CODE, this.journeyService.registratioJourney.data.personalData);
  }

  public setParentage(motherName: string) {
    this.journeyService.registratioJourney.data.personalData.motherName = motherName;
    this.setIsCompleteStepData();
    this.journeyService.changeDataEvent(this.STEP_CODE, this.journeyService.registratioJourney.data.personalData);
  }

  public setNationalityName(nationalityName: string) {
    this.journeyService.registratioJourney.data.personalData.nationalityName = nationalityName;
  }

  public setNationality(nationality: string) {
    this.journeyService.registratioJourney.data.personalData.nationality = nationality;
    this.setIsCompleteStepData();
    this.journeyService.changeDataEvent(this.STEP_CODE, this.journeyService.registratioJourney.data.personalData);
  }

  public setGenderTypeNameData(genderDataName: string, genderCode: string) {
    this.journeyService.registratioJourney.data.personalData.genderName = genderDataName;
    this.journeyService.registratioJourney.data.personalData.genderCode = genderCode;
  }

  public setGenderTypeData(genderDataId: string) {
    this.journeyService.registratioJourney.data.personalData.gender = genderDataId;
    this.setIsCompleteStepData();
    this.journeyService.changeDataEvent(this.STEP_CODE, this.journeyService.registratioJourney.data.personalData);
  }

  public setDocumentDateOfBirthData(date: string) {
    this.journeyService.registratioJourney.data.personalData.dateOfBirth = date;
    this.setIsCompleteStepData();
    this.journeyService.changeDataEvent(this.STEP_CODE, this.journeyService.registratioJourney.data.personalData);
  }


  convertDate(date: string): string {
    let dateString = undefined;
    if (date) {
      dateString = date.split('/').reverse().join('-');
      return dateString
    }
    return dateString;
  }

  setIsCompleteStepData() {
    this.journeyService.registratioJourney.data.personalData.isCompleted = this.personalDataIsComplete();
  }

  personalDataIsComplete(): boolean {
    const props = ['name', 'cpf', 'email', 'dateOfBirth', 'countryOfBirth', 'countryOfBirthName', 'phoneNumber',
      'documentName', 'issuingAgency', 'issuingAgencyName', 'issuingAgencyName', 'expeditionState',
      'expeditionStateName', 'documentType', 'documentTypeName', 'documentNumber', 'nationality', 'nationalityName',
      'motherName', 'gender', 'genderName'];

    const personalData = this.filterObject(this.journeyService.registratioJourney.data.personalData, props);
    const countryBR = 'BRASIL';

    const uFOfBirthIsComplete =
      (this.journeyService.registratioJourney.data.personalData?.countryOfBirthName?.toLocaleUpperCase() === countryBR
        && this.journeyService.registratioJourney.data.personalData?.uFOfBirth !== undefined) ||
        (this.journeyService.registratioJourney.data.personalData?.countryOfBirthName !== undefined
          && this.journeyService.registratioJourney.data.personalData?.countryOfBirthName?.toLocaleUpperCase() !== countryBR)
        ? true : false;

    const cityBirthIsComplete =
      (this.journeyService.registratioJourney.data.personalData?.countryOfBirthName?.toLocaleUpperCase() === countryBR
        && this.journeyService.registratioJourney.data.personalData?.cityOfBirth !== undefined) ||
        (this.journeyService.registratioJourney.data.personalData?.countryOfBirthName !== undefined
          && this.journeyService.registratioJourney.data.personalData?.countryOfBirthName?.toLocaleUpperCase() !== countryBR)
        ? true : false;

    return this.isNotEmpty(personalData) && uFOfBirthIsComplete && cityBirthIsComplete;
  }

  filterObject(data: any, props: string[]) {
    return Object.keys(data)
      .filter(key => props.includes(key))
      .reduce((cur, key) => Object.assign(cur, { [key]: data[key] }), {});
  }

  isNotEmpty(data: any): boolean {
    return Object.values(data).every(value => !!value);
  }

}
